module.exports = __webpack_public_path__ + "img/20220509114720.f7c7278f.png";